module.exports = __webpack_public_path__ + "img/26.8335bae4.jpg";